(function () {
  'use strict';

  var customerEmail = window.__shopifyFormCustomer?.email || '';
  var isLoggedIn = window.__shopifyFormCustomer?.loggedIn || false;
  var hasAddress = window.__shopifyFormCustomer?.hasAddress || false;

  console.log('[FormCustomizer] loggedIn:', isLoggedIn, '| email:', customerEmail, '| hasAddress:', hasAddress);

  if (!isLoggedIn || hasAddress) return;

  function injectPopupStyles(shadowRoot) {
    if (shadowRoot.querySelector('#custom-popup-styles')) return;

    var style = document.createElement('style');
    style.id = 'custom-popup-styles';
    style.textContent = `
      /* Make the root element act as a fixed overlay */
      #app-embed, [data-form-root="true"] {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        background-color: rgba(255, 255, 255, 0.5) !important;
        backdrop-filter: blur(20px) !important;
        -webkit-backdrop-filter: blur(20px) !important;
        z-index: 999999 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 20px !important;
        box-sizing: border-box !important;
      }
      
      /* Make the form container look like a modal dialog */
      section[role="dialog"] {
        background: #ffffff !important;
        border-radius: 0 !important;
        padding: 30px 25px !important;
        width: 90% !important;
        max-width: 500px !important;
        max-height: 90vh !important;
        overflow-y: auto !important;
        box-shadow: 0 10px 40px rgba(0,0,0,0.15) !important;
        position: relative !important;
      }

      /* Hide empty grid item if any */
      ._imageLoading_1q1d2_241 {
        display: none !important;
      }

      /* --- Typography & Colors --- */
      h2, p, legend, label, span {
        color: #1f2a44 !important;
        font-family: inherit !important;
      }
      h2 {
        text-align: center !important;
        font-weight: 800 !important;
        margin-bottom: 10px !important;
        font-size: 24px !important;
      }
      ._textBody_2aowh_10 p {
        text-align: center !important;
        margin-bottom: 10px !important;
      }

      ._textArea_17mgw_1 _invalid_17mgw_14 {
        margin-top: 13px !important;
      }

      /* --- Inputs & Selects --- */
      input[type="text"],
      input[type="email"],
      input[type="tel"],
      input[type="password"],
      textarea,
      select {
        border: 1.5px solid #1f2a44 !important;
        border-radius: 20px !important;
        padding: 12px 20px !important;
        font-size: 14px !important;
        color: #1f2a44 !important;
        background-color: #fff !important;
        box-sizing: border-box !important;
        width: 100% !important;
        outline: none !important;
        margin-top: 5px !important;
      }
      
      input:not([type="radio"]), select {
        height: 48px !important;
      }

      textarea {
        min-height: 80px !important;
        height: auto !important;
        resize: vertical !important;
      }
      
      input:focus, select:focus {
        box-shadow: 0 0 0 1px #1f2a44 !important;
      }

      /* --- Flexbox Trick for Labels --- */
      ._formFieldContainer_1mxsl_5,
      ._formPhoneInputContainer_piv1u_6 {
        display: flex !important;
        flex-direction: column-reverse !important;
        margin-bottom: 15px !important;
        position: relative !important;
        padding-top: 0 !important;
      }

      /* Labels */
      label {
        font-weight: 700 !important;
        font-size: 14px !important;
        position: relative !important;
        transform: none !important;
        top: auto !important;
        left: auto !important;
        margin-bottom: 0 !important;
        align-self: flex-start !important;
      }
      
      /* Red asterisks for fields that are required (we add to all text/email labels except email which is filled) */
      label[id^="label-"]::after {
        content: " *";
        color: #e32c2b !important;
      }
        div._withError_1mxsl_17 > input, ._textArea_17mgw_1._invalid_17mgw_14 {
          box-shadow: none !important;
          border-color: #e32c2b !important;
        }
      /* Remove asterisk from radio button options */
      label._radioField_nw6va_1::after {
        content: "" !important;
      }

      /* --- Phone Input Specifics --- */
      .phone-country-selector {
        position: absolute !important;
        left: 15px !important;
        bottom: 15px !important; /* Bottom since container is flex column-reverse */
        z-index: 10 !important;
        height: 48px !important;
        display: flex !important;
        align-items: center !important;
        top: 20px !important;
        
      }
      ._selectContainer_12thd_6 {
        position: relative !important;
      }
      ._selectContainer_12thd_6, ._selectToggle_12thd_25 {
        border: none !important;
        background: transparent !important;
        box-shadow: none !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      ._selectToggle_12thd_25 {
        display: flex !important;
        align-items: center !important;
      }
      input[type="tel"] {
        padding-left: 65px !important;
      }

      ._flagIcon_py6yc_5 {
        width: 40px !important;
      }


      /* --- Phone Country Dropdown List --- */
      ._dropdownContainer_12thd_63 {
        min-width: 250px !important;
        background-color: #ffffff !important;
        border: 1.5px solid #1f2a44 !important;
        border-radius: 12px !important;
        box-shadow: 0 10px 30px rgba(0,0,0,0.15) !important;
        z-index: 99999 !important;
        padding: 8px 0 !important;
        max-height: 250px !important;
        overflow-y: auto !important;
        left: -15px !important; /* Offset the parent left padding */
        top: 40px !important;
      }
      
      ._dropdownContainer_12thd_63 [role="option"],
      ._dropdownContainer_12thd_63 > * {
        padding: 10px 16px !important;
        font-size: 14px !important;
        color: #1f2a44 !important;
        display: flex !important;
        gap: 12px !important;
        cursor: pointer !important;
        text-align: left !important;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start !important;
      }

      ._dropdownContainer_12thd_63 > *:hover {
        background-color: #f0f2f5 !important;
      }

      ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 _withError_1mxsl_17, ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5  {
        order: 2 !important;
      }

     ._formPhoneInputContainer_piv1u_6  ._formError_1mxsl_21 {
        order: 1 !important;
      }

      ._formFieldContainer_1mxsl_5._withError_1mxsl_17 {
          margin-bottom: 0px !important;
      }
      div._formDisclaimer_cit2d_38 {
        font-family: inherit !important;
      }
      ._formError_1mxsl_21, ._error_1o4ef_1 {
        font-size: 12px !important;
      }

      ._formPhoneInputContainer_piv1u_6 {
        margin-bottom: 0 !important;
      }

      ._formFieldContainer_1mxsl_5:has(textarea)::before {
        content: none !important;
      }

      /* --- Radio Buttons --- */
      ._radioFieldSet_nw6va_1 {
        margin-top: 15px !important;
        border: none !important;
        padding: 0 !important;
      }
      ._radioLegend_nw6va_18 {
        font-weight: 700 !important;
        font-size: 14px !important;
        margin-bottom: 10px !important;
      }
      ._radioLegend_nw6va_18::after {
        content: " *";
        color: #e32c2b !important;
      }
      ._verticalLayout_nw6va_6 {
        display: grid !important;
        grid-template-columns: 1fr 1fr !important;
        gap: 10px !important;
      }
      ._radioField_nw6va_1 {
        display: flex !important;
        align-items: center !important;
        flex-direction: row !important;
      }
      ._radioInput_nw6va_31 {
        margin-right: 8px !important;
        accent-color: #1f2a44 !important;
      }
    ._formFieldContainer_1mxsl_5 textarea {
      margin-top: 5px !important;
    }
      /* --- Submit Button --- */
      button[type="submit"] {
        background-color: #fcd433 !important;
        color: #0e2952 !important;
        border-radius: 20px !important;
        font-weight: bold !important;
        padding: 14px !important;
        width: 100% !important;
        font-size: 16px !important;
        margin-top: 20px !important;
        border: none !important;
        cursor: pointer !important;
        width: auto !important;
      }
      
      button[type="submit"]:hover {
        opacity: 0.9 !important;
      }

      /* Hide class for popup */
      #app-embed.is-hidden, [data-form-root="true"].is-hidden {
        display: none !important;
      }
    `;
    shadowRoot.appendChild(style);
  }

  function customizeForm(shadowRoot) {
    var emailInput = shadowRoot.querySelector('input#email, input[data-testid="field-email"]');
    if (!emailInput) {
      console.log('[FormCustomizer] Email input not found in shadow root');
      return false;
    }

    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    ).set;
    nativeInputValueSetter.call(emailInput, customerEmail);
    emailInput.dispatchEvent(new Event('input', { bubbles: true }));
    emailInput.dispatchEvent(new Event('change', { bubbles: true }));

    emailInput.setAttribute('readonly', 'readonly');
    emailInput.style.opacity = '0.7';
    emailInput.style.pointerEvents = 'none';
    emailInput.style.backgroundColor = '#f5f5f5';

    injectPopupStyles(shadowRoot);
    document.body.style.overflow = 'hidden';

    var logoutLink = shadowRoot.querySelector('a[href*="logout"]');
    if (!logoutLink) {
      var allLinks = shadowRoot.querySelectorAll('a');
      for (var i = 0; i < allLinks.length; i++) {
        if (allLinks[i].textContent.toLowerCase().indexOf('log out') > -1) {
          logoutLink = allLinks[i];
          break;
        }
      }
    }
    
    if (logoutLink) {
      var dynamicLogoutUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.account_logout_url) || '/account/logout';
      logoutLink.setAttribute('href', dynamicLogoutUrl);
      logoutLink.removeAttribute('target');
      console.log('[FormCustomizer] Updated logout link to:', dynamicLogoutUrl);
    }

    console.log('[FormCustomizer] Email filled and form styled as popup');

    var observer = new MutationObserver(function(mutations) {
      var successBanner = shadowRoot.querySelector('[data-testid="banner-success"]');
      var root = shadowRoot.querySelector('[data-form-root="true"]');
      
      if (successBanner || (root && root.getAttribute('data-current-step') === 'success')) {
        console.log('[FormCustomizer] Success detected, unlocking scroll');
        document.body.style.overflow = '';
        
        setTimeout(function() {
          if (root) {
            root.style.setProperty('display', 'none', 'important');
            root.classList.add('is-hidden');
          }
          var host = shadowRoot.host;
          if (host) {
            host.style.setProperty('display', 'none', 'important');
          }
          console.log('[FormCustomizer] Popup and host hidden with !important');
        }, 1000);
        
        observer.disconnect();
      }
    });

    observer.observe(shadowRoot, { 
      childList: true, 
      subtree: true, 
      attributes: true, 
      attributeFilter: ['data-current-step'] 
    });


    return true;
  }

  var attempts = 0;
  var maxAttempts = 100; // 10 seconds

  var poll = setInterval(function () {
    attempts++;

    // Find the specific form embed by its new ID
    var targetContainer = document.querySelector('[data-forms-id="forms-root-980204"]');
    var embed = targetContainer ? targetContainer.querySelector('shopify-forms-embed') : null;

    if (embed) {
      var sr = embed.shadowRoot;
      if (sr) {
        var form = sr.querySelector('form[data-testid="form"]');
        if (form) {
          console.log('[FormCustomizer] Found target form 980204');
          var success = customizeForm(sr);
          if (success) {
            clearInterval(poll);
            return;
          }
        }
      }
    }

    if (attempts >= maxAttempts) {
      clearInterval(poll);
      console.log('[FormCustomizer] Gave up after', maxAttempts, 'attempts');
    }
  }, 100);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  });
})();
